import React from 'react';

import { TableBody } from '@material-ui/core';

import { IResult } from '../../../../../../store/admin/roundResults/store';
import { IAdminTeamResult } from '../../../../../../store/admin/teamResults/store';

import { useAssignResultsState } from '../../AssignResults/Context/AssignResults.context';
import ResultsTableRow from './ResultsTableRow';
import { TeamResultsTableRow } from './TeamResultsTableRow';
import CTPTableBody from './CTPTableBody';

const ResultsTableBody = () => {
  const {
    results,
    selectedCombination,
    sortedResults,
    horseRaceEliminatedResults,
    teamResults
  } = useAssignResultsState();

  return selectedCombination ? (
    selectedCombination.format.format.prefix === 'teamstroke' ? (
      <TableBody className="results-table-table-body">
        {teamResults.map((result: IAdminTeamResult, index: number) => (
          <TeamResultsTableRow key={`${index}-${result.flightId}`} result={result} />
        ))}
      </TableBody>
    ) : selectedCombination.format.format.prefix === 'ctp' ? (
      <CTPTableBody />
    ) : results.length > 0 ? (
      <TableBody className="results-table-table-body">
        {selectedCombination.format.format.prefix === 'horse'
          ? [
              horseRaceEliminatedResults.false &&
                horseRaceEliminatedResults.false.map((result: IResult, index: number) => (
                  <ResultsTableRow
                    key={`${index}-${result.flightId}`}
                    result={result}
                    showNoPosition={true}
                  />
                )),
              horseRaceEliminatedResults.true &&
                horseRaceEliminatedResults.true.map((result: IResult, index: number) => (
                  <ResultsTableRow key={`${index}-${result.flightId}`} result={result} />
                ))
            ]
          : sortedResults.map((result: IResult, index: number) => (
              <ResultsTableRow key={`${index}-${result.flightId}`} result={result} />
            ))}
      </TableBody>
    ) : (
      <></>
    )
  ) : (
    <></>
  );
};

export default ResultsTableBody;
